module.exports = __webpack_public_path__ + "files/2e5ba0fe1c934243f8a06c191c305883.png";